module.exports = __webpack_public_path__ + "img/empty.a05c5341.png";